import { Component, inject } from '@angular/core';
import { RouteCorridorService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  RouteCorridorCreateDto,
  RouteCorridorDto,
  RouteCorridorExcelDownloadDto,
  RouteCorridorUpdateDto,
} from '../proxy/controlling/dtos/route-corridor';
import { ROUTECORRIDOR_CONFIG, ROUTECORRIDOR_FIELDS } from './route-corridor.config';
import { BaseCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-route-corridor',
  imports: [
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, RouteCorridorService, ConfirmationService],
  templateUrl: './route-corridor.html',
  styleUrl: './route-corridor.scss',
})
export class RouteCorridor extends BaseCrudComponent<
  RouteCorridorDto,
  RouteCorridorCreateDto,
  RouteCorridorUpdateDto,
  RouteCorridorExcelDownloadDto
> {
  service = inject(RouteCorridorService);
  config = ROUTECORRIDOR_CONFIG;
  fields = ROUTECORRIDOR_FIELDS;

  protected prepareUpdateDto(data: any, selected: RouteCorridorDto): RouteCorridorUpdateDto {
    return {
      name: data.name,
      code: data.code,
      tariffsModuleId: data.tariffsModuleId,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'RouteCorridor';
  }
}
